import { render, staticRenderFns } from "./SelectDepartament.vue?vue&type=template&id=3df7a404"
import script from "./SelectDepartament.vue?vue&type=script&lang=js"
export * from "./SelectDepartament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports